import React from "react";
import { SettingsPage } from "@components/organizationView/settings/SettingsPage";
import { useTypedFlags } from "@hooks/useTypedFlags";
import { OrganizationTaskGroups } from "./WorkspaceTaskGroups/OrganizationTaskGroups";
import { OrganizationClosesSettingsPage } from "./OrganizationCloses/OrganizationClosesSettingsPage";
import { SettingsTabPane } from "./SettingsTabPane";
import { OrganizationSettingsPages } from "./constants";

export const OrganizationPanes: React.FC = () => {
    const { closeManagement } = useTypedFlags();

    return (
        <>
            <SettingsTabPane
                eventKey={OrganizationSettingsPages.FIRM_INFORMATION}
            >
                <SettingsPage />
            </SettingsTabPane>

            <SettingsTabPane eventKey={OrganizationSettingsPages.TASK_GROUPS}>
                <OrganizationTaskGroups />
            </SettingsTabPane>

            {closeManagement && (
                <SettingsTabPane eventKey={OrganizationSettingsPages.CLOSES}>
                    <OrganizationClosesSettingsPage />
                </SettingsTabPane>
            )}
        </>
    );
};
